<div class="wrapper">
  <span class="action-button" (mouseover)="showInfo()">
    <i class="fa fa-sticky-note-o"></i>
  </span>

  <template #target></template>
</div>
